module.exports = __webpack_public_path__ + "img/home_img2.314f2794.jpg";